import { useEffect, useState } from "react";

const THEME_DATA_ATTRIBUTE = "data-theme";
const THEME_DARK = "dark";

const readIsDarkMode = () =>
  typeof document !== "undefined" &&
  document.documentElement.getAttribute(THEME_DATA_ATTRIBUTE) === THEME_DARK;

const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(readIsDarkMode);

  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === THEME_DATA_ATTRIBUTE) {
          setIsDarkMode(html.getAttribute(THEME_DATA_ATTRIBUTE) === THEME_DARK);
        }
      }
    });
    observer.observe(html, { attributes: true, childList: false, subtree: false });
    return () => observer.disconnect();
  }, []);

  return isDarkMode;
};

export default useDarkMode;
